import compose from 'recompose/compose';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import OwnerPaymentCard from '../../../common/ownerPaymentCard/OwnerPaymentCardContainer';
import { getIsReadOnlyAdminUser } from '../../../auth/selectors';

export default compose(
  withRouter,
  connect((state, props) => ({
    ownerId: props.params.id,
    ownerType: 'brand',
    disabled: getIsReadOnlyAdminUser(state),
  }))
)(OwnerPaymentCard);
